export var sliceString = function sliceString(string, slice) {
  if (slice === void 0) {
    slice = 128;
  }

  if (string.length >= slice) {
    return string.slice(0, slice) + "...";
  }

  return string;
};